module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tracking_desktop-927deea195ff8e6b7c118cff6a4047e6.png";